import {bugsnag} from "./bugsnag";
import {createOrder} from "./create-order";

const BFF_ROOT = 'apigw-bff-dev.alaric.bg/fund-portal';

export const environment = {
	...bugsnag,
	bugsnagReleaseStage: 'dev',

	...createOrder,

	production: false,

	portal: 'AlaricFundPortal',
	portalId: 4,
	tenant: 1,

	pwa: true,

	defaultLanguage: 'bg',
	componentTemplateFile: './tenants/alaric.html',
	componentStyleFile: './tenants/alaric.scss',

	enrollChannel: 'W',

	mainSiteUrl: 'https://alaric.bg/',
	privacyPolicyUrl: 'https://alaric.bg/legal-and-regulatory-information/',
	platformUrl: 'https://myportal-dev.alaric.bg/',
	platformRedirectUrl: 'https://myportal-dev.alaric.bg/authentication/login',
	platformConfirmEmailUrl: 'https://myportal-dev.alaric.bg/authentication/confirm-email',
	myPortalTradeUrl: 'https://myportal-trade-dev.alaric.bg/overview?directLogin=true',

	crmApiUrl: `https://${BFF_ROOT}/customer/api/v1/`,
	crmBaseApiUrl: `https://${BFF_ROOT}/customer/api/`,
	amsApiUrl: `https://${BFF_ROOT}/message/api/`,
	reportingNetApiUrl: `https://${BFF_ROOT}/reporting/api/v1/`,
	reportingNetBaseApiUrl: `https://${BFF_ROOT}/reporting/api/`,
	authUrl: `https://${BFF_ROOT}`,
	fundOrdersApiUrl: `https://${BFF_ROOT}/fund-orders/api/v1/`,
	filesApiUrl: `https://${BFF_ROOT}/file/v1/`,
	cdnUrl: 'https://cdn-dev.alaricsecurities.net/',

	authId: 'AlaricFund',
	authSignUpToken: 'sign_up_token',
	authScopes: [
		'roles',
		'TokenserverAPI.write',
		'TokenserverAPI.read',
		'tenant',
		'Alaric.FileStorage',
		'offline_access',
		'Alaric.Payment',
		'Alaric.Gateway',
		'Alaric.CRM',
		'IdentityServerApi',
		'phone',
		'two_factor_enabled',
		'Alaric.Audit',
		'Alaric.Subscription',
		'Alaric.Entitlement',
		'Alaric.Reporting',
		'platform',
		'Alaric.MarketData',
		'user_relation',
		'Alaric.News',
		'Alaric.Tapi',
		'Alaric.Fundamental',
		'openid',
		'profile',
		'email',
		'Alaric.MS',
		'Alaric.Administrative',
		'Alaric.FundOrders',
	].join(' '),

	bffLoginUrl: `https://${BFF_ROOT}/bff/login`,
	bffUserUrl: `https://${BFF_ROOT}/bff/user`,
	bffLogoutUrl: `https://${BFF_ROOT}/bff/logout`,
	bffOnboardingRedeemSignupUrl: `https://${BFF_ROOT}/bff/onboarding/redeem-signup`,

	useStorage: true,
	storageTtl: 3600000,

	randomGeneratedStorageCollectionKey: 'PJLz9rWZnZnQanpnvOQWECtyWmyMfYwP',

	customCacheResponseHeader: 'X-Cacheable-Response',
	customProtectedApiHeader: 'X-Protected-Api',

	datePickerFormat: 'DD/MM/YY',
	datePickerFormatBulgarian: 'DD/MM/YY',
	dateViewFormat: 'dd/MM/yyyy',
	dateShortFormat: 'dd.MM.yyyy',
	dateViewFormatBulgarian: 'dd/MM/yyyy',
	dateFormatLocalDate: 'YYYY-MM-DD',
	dateAndTimeFormat: 'dd.MM.yyyy HH:mm:ss',
	googleDataAnalyzeKey: 'GTM-N4KZ5N7L'
};
